import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Main as MainLayout, } from '../../../layouts';
import configBase from '../../../configBase';
import {verificaCache} from '../../../verificaCache';
import axios from 'axios';
import '../../../assets/scss/linkvendedor.scss';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import IconButton from '@material-ui/core/IconButton';



class LinkVendedor extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      linkSite: '',

      errorRequest: false,
      msgErrorRequest: '',
      successRequest: false,
      msgSuccessRequest: '',
    };

  }

  componentDidMount() {
    verificaCache(function (vc) {
      if (vc.erro === false)
        this.getData();
      else
        this.setError(vc.mensagem);
    }.bind(this));
  }

  getData() {
    let url = configBase.api + 'Salesmans/?filter={"where":{"userId":"' + localStorage.getItem('planos_u') + '"}}&access_token='+localStorage.getItem('planos_t');

    axios.get(url)
    .then((response) => {
      let state = this.state;

      state.linkSite = response.data[0].linkSite;
      this.setState(state);
    })
    .catch(function () {
      this.setError('Problema encontrado ao buscar link do vendedor');
    }.bind(this));
  }

  copyFn(id) {
    let copyText = document.getElementById(id);
    copyText.select();
    copyText.setSelectionRange(0, 99999); /*For mobile devices*/
    document.execCommand("copy");
    this.setSuccess('Link copiado');
  }

  emptyFunction() {
    // Função criada apenas para retirar erro de obrigatorie dade do componente
  }

  setError(msg) {
    let state = this.state;
    state.errorRequest = true;
    state.msgErrorRequest = msg;
    this.setState(state);
  }

  errorClose() {
    let state = this.state;
    state.errorRequest = false;
    state.msgErrorRequest = '';
    this.setState(state);
  }

  setSuccess(msg) {
    let state = this.state;
    state.successRequest = true;
    state.msgSuccessRequest = msg;
    this.setState(state);
  }

  successClose() {
    let state = this.state;
    state.successRequest = false;
    state.msgSuccessRequest = '';
    this.setState(state);
  }


  render() {

    return (
      <MainLayout history={this.props.history}>
        <div id="linkVendedor" className={{flexGrow: 1}}>
          <Paper elevation={0} className="paper">
            <Typography variant="button" gutterBottom>
              LINK DO VENDEDOR
            </Typography>
          </Paper>

          <div id="linkVendedorConteudo" className="contentepanel">
            <Card>
              <CardHeader
                className="title_docs"
                title="Planos Pessoa Física"
              />

              <Divider/>

              <div>
                <Grid container spacing={2} style={{padding: '15px'}}>
                  <Grid item xs={12} sm={12} md={10} lg={10} style={{cursor: 'pointer'}}>
                    <a
                      href={configBase.front+"pessoafisica?vendedor="+this.state.linkSite}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <TextField
                        label=""
                        variant="filled"
                        disabled
                        value={configBase.front+"pessoafisica?vendedor="+this.state.linkSite}
                        fullWidth
                        size="small"
                        className="linkvendedor_input"
                      />
                    </a>
                  </Grid>
                  <Grid item xs={12} sm={12} md={2} lg={2}>
                    <div className="icon_whats">
                      <Tooltip title="Whatsapp">
                        <a
                          style={{color:"#606060"}}
                          href={"whatsapp://send?text=Acesse agora a minha página e contrate o seu plano odontológico: "+
                          configBase.front+"pessoafisica?vendedor="+this.state.linkSite}
                        >
                          <IconButton component="span">
                            <WhatsAppIcon/>
                          </IconButton>
                        </a>
                      </Tooltip>

                      <Tooltip title="Copiar">
                        <IconButton component="span" onClick={this.copyFn.bind(this, 'i_pessoafisica')}>
                          <FileCopyIcon
                            style={{cursor: 'pointer', color:"#606060"}}
                          />
                        </IconButton>
                      </Tooltip>

                      <input
                        id="i_pessoafisica"
                        style={{position: 'absolute', left: '-99999px'}}
                        type="texte"
                        value={configBase.front+"pessoafisica?vendedor="+this.state.linkSite}
                        onChange={this.emptyFunction}
                      />
                    </div>
                  </Grid>
                </Grid>
              </div>
            </Card>

            <Card style={{marginTop: 15}}>
              <CardHeader
                className="title_docs"
                title="Planos Pessoa Jurídica"
              />

              <Divider/>

              <div>
                <Grid container spacing={2} style={{padding: '15px'}}>
                  <Grid item xs={12} sm={12} md={10} lg={10} style={{cursor: 'pointer'}}>
                    <a
                      href={configBase.front+"pessoajuridica?vendedor="+this.state.linkSite}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <TextField
                        label=""
                        variant="filled"
                        disabled
                        value={configBase.front+"pessoajuridica?vendedor="+this.state.linkSite}
                        fullWidth
                        size="small"
                        className="linkvendedor_input"
                      />
                    </a>
                  </Grid>
                  <Grid item xs={12} sm={12} md={2} lg={2}>
                    <div className="icon_whats">
                      <Tooltip title="Whatsapp">
                        <a
                          style={{color:"#606060"}}
                          href={"whatsapp://send?text=Acesse agora a minha página e contrate o seu plano odontológico: "+
                          configBase.front+"pessoajuridica?vendedor="+this.state.linkSite}
                        >
                          <IconButton component="span">
                            <WhatsAppIcon/>
                          </IconButton>
                        </a>
                      </Tooltip>

                      <Tooltip title="Copiar">
                        <IconButton component="span" onClick={this.copyFn.bind(this, 'i_pessoajuridica')}>
                          <FileCopyIcon
                            style={{cursor: 'pointer', color:"#606060"}}
                          />
                        </IconButton>
                      </Tooltip>

                      <input
                        id="i_pessoajuridica"
                        style={{position: 'absolute', left: '-99999px'}}
                        type="texte"
                        value={configBase.front+"pessoajuridica?vendedor="+this.state.linkSite}
                        onChange={this.emptyFunction}
                      />
                    </div>
                  </Grid>
                </Grid>
              </div>
            </Card>

            <Card style={{marginTop: 15}}>
              <CardHeader
                className="title_docs"
                title="Planos Servidor Público"
              />

              <Divider/>

              <div>
                <Grid container spacing={2} style={{padding: '15px'}}>
                  <Grid item xs={12} sm={12} md={10} lg={10} style={{cursor: 'pointer'}}>
                    <a
                      href={configBase.front+"servidorpublico?vendedor="+this.state.linkSite}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <TextField
                        label=""
                        variant="filled"
                        disabled
                        value={configBase.front+"servidorpublico?vendedor="+this.state.linkSite}
                        fullWidth
                        size="small"
                        className="linkvendedor_input"
                      />
                    </a>
                  </Grid>
                  <Grid item xs={12} sm={12} md={2} lg={2}>
                    <div className="icon_whats">
                      <Tooltip title="Whatsapp">
                        <a
                          style={{color:"#606060"}}
                          href={"whatsapp://send?text=Acesse agora a minha página e contrate o seu plano odontológico: "+
                          configBase.front+"servidorpublico?vendedor="+this.state.linkSite}
                        >
                          <IconButton component="span">
                            <WhatsAppIcon/>
                          </IconButton>
                        </a>
                      </Tooltip>

                      <Tooltip title="Copiar">
                        <IconButton component="span" onClick={this.copyFn.bind(this, 'i_servidorpublico')}>
                          <FileCopyIcon
                            style={{cursor: 'pointer', color:"#606060"}}
                          />
                        </IconButton>
                      </Tooltip>

                      <input
                        id="i_servidorpublico"
                        style={{position: 'absolute', left: '-99999px'}}
                        type="texte"
                        value={configBase.front+"servidorpublico?vendedor="+this.state.linkSite}
                        onChange={this.emptyFunction}
                      />
                    </div>
                  </Grid>
                </Grid>
              </div>
            </Card>

            <Card style={{marginTop: 15}}>
              <CardHeader
                className="title_docs"
                title="Inclusão de Dependentes"
              />

              <Divider/>

              <div>
                <Grid container spacing={2} style={{padding: '15px'}}>
                  <Grid item xs={12} sm={12} md={10} lg={10} style={{cursor: 'pointer'}}>
                    <a
                      href={configBase.front+"inclusao?vendedor="+this.state.linkSite}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <TextField
                        label=""
                        variant="filled"
                        disabled
                        value={configBase.front+"inclusao?vendedor="+this.state.linkSite}
                        fullWidth
                        size="small"
                        className="linkvendedor_input"
                      />
                    </a>
                  </Grid>
                  <Grid item xs={12} sm={12} md={2} lg={2}>
                    <div className="icon_whats">
                      <Tooltip title="Whatsapp">
                        <a
                          style={{color:"#606060"}}
                          href={"whatsapp://send?text=Acesse agora a minha página e inclua um dependente em seu plano: "+
                          configBase.front+"inclusao?vendedor="+this.state.linkSite}
                        >
                          <IconButton component="span">
                            <WhatsAppIcon/>
                          </IconButton>
                        </a>
                      </Tooltip>

                      <Tooltip title="Copiar">
                        <IconButton component="span" onClick={this.copyFn.bind(this, 'i_inclusao')}>
                          <FileCopyIcon
                            style={{cursor: 'pointer', color:"#606060"}}
                          />
                        </IconButton>
                      </Tooltip>

                      <input
                        id="i_inclusao"
                        style={{position: 'absolute', left: '-99999px'}}
                        type="texte"
                        value={configBase.front+"inclusao?vendedor="+this.state.linkSite}
                        onChange={this.emptyFunction}
                      />
                    </div>
                  </Grid>
                </Grid>
              </div>
            </Card>

          </div>

          <Snackbar open={this.state.errorRequest} autoHideDuration={5000} onClose={this.errorClose.bind(this)}>
            <MuiAlert className="snackbarStyle" onClose={this.errorClose.bind(this)} severity="error" variant="filled" elevation={6}>
              {this.state.msgErrorRequest}
            </MuiAlert>
          </Snackbar>

          <Snackbar open={this.state.successRequest} autoHideDuration={1000} onClose={this.successClose.bind(this)}>
            <MuiAlert className="snackbarStyle" onClose={this.successClose.bind(this)} severity="success" variant="filled" elevation={6}>
              {this.state.msgSuccessRequest}
            </MuiAlert>
          </Snackbar>
        </div>
      </MainLayout>
    );

  }

}

LinkVendedor.propTypes = {
  history: PropTypes.object
};

export default withRouter(LinkVendedor);